require("./provider-types-display-list.scss");

import {ChangeDetectionStrategy, Component, computed, input, output} from "@angular/core";
import {bzIconCloseCircle} from "@bringoz/ui/icons";

@Component({
  selector: "app-provider-types-display-list",
  templateUrl: "./provider-types-display-list.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProviderTypesDisplayListComponent {
  readonly providerTypes = input<string[]>();
  readonly providerTypesChange = output<string[]>();

  readonly removeIcon = bzIconCloseCircle;
  readonly items = computed(() => this.providerTypes()?.length ? this.providerTypes() : []);

  onRemove(event: MouseEvent, providerType: string): void {
    event.stopPropagation();
    this.providerTypesChange.emit((this.providerTypes() ?? []).filter((type) => type !== providerType));
  }
}
